import { ROUTE_NAMES } from '../constants/router';

export const routes = [
  {
    path: '/analyticsimport/IndicatorLoadMonitoring',
    name: 'IndicatorLoadMonitoring',
    component: () => import('../views/IndicatorLoadMonitoring.vue'),
  },
  {
    path: '/analyticsimport/exportpotential',
    name: 'ExportPotential',
    component: () => import('../views/ExportPotential.vue'),
  },
  {
    path: '/analyticsimport/exportpotential/edit/:id',
    name: 'ExportPotentialCard',
    component: () => import('../views/ExportPotentialCard.vue'),
  },
  {
    path: '/analyticsimport/exportpotentialservices',
    name: 'ExportPotentialService',
    component: () => import('../views/ExportPotentialService.vue'),
  },
  {
    path: '/analyticsimport/exportpotentialservices/edit/:id',
    name: 'ExportPotentialServiceCard',
    component: () => import('../views/ExportPotentialServiceCard.vue'),
  },
  {
    path: '/analyticsimport/macroeconomicindicators',
    name: 'MacroeconomicIndicators',
    component: () => import('../views/MacroeconomicIndicators.vue'),
  },
  {
    path: '/analyticsimport/FCS',
    name: 'ExportProduct',
    component: () => import('../views/ExportProduct.vue'),
  },
  {
    path: '/analyticsimport/Fts',
    name: 'FtsCustoms',
    component: () => import('../views/FtsCustoms.vue'),
  },
  {
    path: '/analyticsimport/greeneconomy',
    name: 'GreenEconomy',
    component: () => import('../views/GreenEconomy.vue'),
  },
  {
    path: '/analyticsimport/investments',
    name: 'InvestmentList',
    component: () => import('../views/InvestmentList.vue'),
  },
  {
    path: '/analyticsimport/rating',
    name: 'CountryRatings',
    component: () => import('../views/CountryRatings.vue'),
  },
  {
    path: '/analyticsimport/budgetpolicy',
    name: 'BudgetPolicy',
    component: () => import('../views/BudgetPolicy.vue'),
  },
  {
    path: '/analyticsimport/foreigntrade',
    name: 'ForeignTrade',
    component: () => import('../views/ForeignTrade.vue'),
  },
  {
    path: '/analyticsimport/tecworld',
    name: 'TecWorld',
    component: () => import('../views/TecWorld.vue'),
  },
  {
    path: '/analyticsimport/tecrelrussia',
    name: 'TradeEconomicRelRussia',
    component: () => import('../views/TradeEconomicRelRussia.vue'),
  },
  {
    path: '/analyticsimport/citizens',
    name: 'CitizensTourism',
    component: () => import('../views/CitizensTourism.vue'),
  },
  {
    path: '/analyticsimport/finsector',
    name: 'FinancialSector',
    component: () => import('../views/FinancialSector.vue'),
  },
  {
    path: '/analyticsimport/lifeindex',
    name: 'LifeIndex',
    component: () => import('../views/LifeIndex.vue'),
  },
  {
    path: '/analyticsimport/striindex',
    name: 'StriIndex',
    component: () => import('../views/StriIndex.vue'),
  },
  {
    path: '/analyticsimport/bankrate',
    name: 'BankRate',
    component: () => import('../views/BankRate.vue'),
  },
  {
    path: '/analyticsimport/investmentsrussia',
    name: 'InvestmentRussia',
    component: () => import('../views/InvestmentRussia.vue'),
  },
  {
    path: '/analyticsimport/investmentsrussia/view/:id',
    name: 'InvestmentRussiaCard',
    component: () => import('../views/InvestmentRussiaCard.vue'),
  },
  {
    path: '/analyticsimport/realpersonalincome',
    name: 'RealDisposablePersonalIncome',
    component: () => import('../views/RealDisposablePersonalIncome.vue'),
  },
  {
    path: '/analyticsimport/intinvestposition',
    name: 'InternationalInvestmentPosition',
    component: () => import('../views/InternationalInvestmentPosition.vue'),
  },
  {
    path: '/analyticsimport/foreigntradeturnoverworld',
    name: 'ForeignTradeTurnoverWorld',
    component: () => import('../views/ForeignTradeTurnoverWorld.vue'),
  },
  {
    path: '/analyticsimport/healthcare',
    name: 'HealthcareStats',
    component: () => import('../views/HealthcareStats.vue'),
  },
  {
    path: '/analyticsimport/healthcare/edit/:id',
    name: 'HealthcareStatsCard',
    component: () => import('../views/HealthcareStatsCard.vue'),
  },
  {
    path: '/analyticsimport/worldprice',
    name: 'WorldPrice',
    component: () => import('../views/WorldPrice.vue'),
  },
  {
    path: '/analyticsimport/worldprice/edit/:id',
    name: 'WorldPriceCard',
    component: () => import('../views/WorldPriceCard.vue'),
  },
  {
    path: '/analyticsimport/inflation',
    name: 'InflationRate',
    component: () => import('../views/InflationRate.vue'),
  },
  {
    path: '/analyticsimport/priority-import-and-import-destination',
    name: 'PriorityImportAndImportDestination',
    component: () => import('../views/PriorityImportAndImportDestination.vue'),
  },
  {
    path: '/analyticsimport/unfriendly-country-statuses',
    name: 'UnfriendlyCountryStatuses',
    component: () => import('../views/UnfriendlyCountryStatuses.vue'),
  },
  {
    path: '/analyticsimport/countrycreditrating',
    name: 'CountryCreditRating',
    component: () => import('../views/CountryCreditRating.vue'),
  },
  {
    path: '/analyticsimport/countrymapping',
    name: 'CountryMapping',
    component: () => import('../views/CountryMapping.vue'),
  },
  {
    path: '/analyticsimport/favortrading',
    name: 'Favortrading',
    component: () => import('../views/FavorTrading.vue'),
  },
  {
    path: '/analyticsimport/foreigninvestment',
    name: 'Foreigninvestment',
    component: () => import('../views/ForeignInvestment.vue'),
  },
  {
    path: '/analyticsimport/key-country-indicator',
    name: 'KeyCountryIndicator',
    component: () => import('../views/KeyCountryIndicator.vue'),
  },
  {
    path: '/analyticsimport/key-country-indicator/add',
    name: ROUTE_NAMES.keyCountryIndicator.add,
    component: () => import('../views/KeyCountryIndicatorAdd.vue'),
  },
  {
    path: '/analyticsimport/key-country-indicator/edit/:id(\\d+)',
    name: ROUTE_NAMES.keyCountryIndicator.edit,
    component: () => import('../views/KeyCountryIndicatorEdit.vue'),
  },
  {
    path: '/analyticsimport/importpotential',
    name: 'ImportPotential',
    component: () => import('../views/ImportPotential.vue'),
  },
  {
    path: '/analyticsimport/importpotential/edit/:id',
    name: 'ImportPotentialCard',
    component: () => import('../views/ImportPotentialCard.vue'),
  },
  {
    path: '/analyticsimport/swagger-upload',
    name: 'SwaggerUpload',
    component: () => import('../views/SwaggerUpload.vue'),
  },
];
